

















































import Vue from 'vue'
import PastLetter from '@/components/PastLetter.vue'
import { ProcessLog } from '@/store/workflow/types'
import { Letter, DiaryEntry, isLetter } from '@/store'
import { TaskLog } from '@/store/workflow/types'
import { CaseWithMessages } from '@/queries/cases.graphql'

export default Vue.extend({
  components: {
    PastLetter,
  },
  computed: {
    waitsInWaitList(): boolean {
      const processes = this.$store.getters['workflow/activeProcesses'] as ProcessLog[]
      return processes.some(p => p.business_key === 'wait-list-assessment')
    },
    letters(): Array<Letter | DiaryEntry> {
      return this.$store.getters.pastLetters
    },
    t0(): Letter[] {
      console.debug('doneOrDue', this.doneOrDue)
      console.debug('isLetter', isLetter)
      if (this.doneOrDue('read-t0')) {
        return this.letters.filter(l => isLetter(l) && l.code == 't0') as Letter[]
      } else {
        return []
      }
    },
    t1(): Letter[] {
      console.debug('doneOrDue', this.doneOrDue)
      console.debug('isLetter', isLetter)
      if (this.doneOrDue('read-t1', 'read-tx')) {
        return this.letters.filter(l => isLetter(l) && l.code == 't1') as Letter[]
      } else {
        return []
      }
    },
    allLettersExceptT0AndT1(): Array<Letter | DiaryEntry> {
      return this.letters.filter(l => !isLetter(l) || !['t0', 't1'].includes(l.code))
    },
  },
  methods: {
    doneOrDue(...taskDefinitionKeys: string[]): boolean {
      const doneTasks: TaskLog[] = this.$store.getters['workflow/doneTasks'] || []
      const dueTasks: TaskLog[] = this.$store.getters['worfklow/dueTasks'] || []
      console.debug('doneTasks', doneTasks)
      console.debug('dueTasks', dueTasks)
      const allTasks = [...doneTasks, ...dueTasks]
      return allTasks.some(t => taskDefinitionKeys.includes(t.task_definition_key))
    },
  },
  apollo: {
    pickedCase: {
      query() {
        return CaseWithMessages
      },
      fetchPolicy: 'no-cache',
      variables() {
        return {
          id: this.$store.getters.currentCaseId
        }
      },
    },
  },
})
